import { FC } from 'react';
import { Button } from '@/common/components/ui/button';
import { ExternalLink } from 'lucide-react';

const WritingSample: FC = () => {
  const samples = [
    {
      title: '1L Writing Sample',
      description: 'A sample of legal writing from my first year of law school.',
      date: 'Spring 2023',
      link: '/assets/docs/writing-sample.pdf',
    },
    {
      title: 'Crisis Communications Plan',
      description: 'A comprehensive plan for managing communications during a major hurricane.',
      date: '2021',
      link: null, // No file available yet
    },
  ];

  return (
    <div className="space-y-12">
      <div className="text-center">
        <h1 className="text-4xl md:text-5xl font-bold text-gray-900">Writing Samples</h1>
        <p className="mt-3 text-lg text-gray-600">A selection of my professional and academic writing.</p>
      </div>

      <div className="grid md:grid-cols-2 gap-8">
        {samples.map((sample, index) => (
          <div key={index} className="bg-white p-8 rounded-lg shadow-md border border-gray-200 flex flex-col">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">{sample.title}</h3>
            <p className="text-gray-500 text-sm mb-4">{sample.date}</p>
            <p className="text-gray-700 flex-grow">{sample.description}</p>
            <div className="mt-6">
              {sample.link ? (
                <Button asChild>
                  <a href={sample.link} target="_blank" rel="noopener noreferrer">
                    <ExternalLink className="mr-2 h-4 w-4" />
                    View PDF
                  </a>
                </Button>
              ) : (
                <Button variant="outline" disabled>
                  Available Upon Request
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default WritingSample;
